import React, { forwardRef } from "react";

import BaseButton, { ActionButtonProps, ButtonProps as BaseButtonProps } from "./Button";

export type ButtonProps = Omit<BaseButtonProps & { iconButton?: false }, "iconButton" | "type" | "label" | "to"> & {
  type?: "button" | "submit";
  children: string;
} & ActionButtonProps;

/** This is just a wrapper now around the "base" Button class at design-system/Button/Button, but you can still use it, it's fine */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ type, children, className, ...props }, ref) => (
  <BaseButton ref={ref} className={className} {...props} submit={type === "submit"} label={children} />
));

export default Button;
